import React, { Component } from 'react';
import { GET_LIST } from 'admin-on-rest';
import restClient from '../restClient';

const styles = {
    wrap: { padding: '10px 16px 0', fontSize: 13, color: '#37474f', clear: 'both' },
};

const fmtEur = (n) => `€ ${Number(n).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

class SiteclickSummary extends Component {
    state = { loading: false, data: null };

    componentDidMount() {
        this.fetchSummary();
    }

    componentDidUpdate(prevProps) {
        const keys = ['from_date', 'to_date', 'cloudhintsdomains_id', 'user_id'];
        const prev = prevProps.filterValues || {};
        const curr = this.props.filterValues || {};
        if (keys.some((k) => prev[k] !== curr[k])) this.fetchSummary();
    }

    fetchSummary = () => {
        const { from_date, to_date, cloudhintsdomains_id, user_id } = this.props.filterValues || {};

        this.setState({ loading: true });
        restClient(GET_LIST, 'admin/siteclick_summary', {
            filter: { from_date, to_date, cloudhintsdomains_id, user_id },
            sort: {},
            pagination: { page: 1, perPage: 1 },
            response_single: true,
        })
            .then(({ data }) => this.setState({ loading: false, data }))
            .catch(() => this.setState({ loading: false, data: null }));
    };

    render() {
        const { data, loading } = this.state;
        if (loading && !data) return <div style={styles.wrap}>Totalen laden...</div>;
        if (!data) return null;

        return (
            <div style={styles.wrap}>
                <strong>{data.count.toLocaleString('nl-NL')}</strong> kliks die meetellen voor deze filters
                {data.count > 0 && (
                    <span> &middot; totaal <strong>{fmtEur(data.total_cost)}</strong> &middot; gem. CPC <strong>{fmtEur(data.avg_cpc)}</strong></span>
                )}
            </div>
        );
    }
}

export default SiteclickSummary;



// WEBPACK FOOTER //
// ./src/siteclicks/SiteclickSummary.js